// Packages
import { createApp, defineAsyncComponent } from 'vue';

// Vue components
import SearchList from '@vue-components/SearchList.vue';

export default function init(): void {
  // Create Vue instance for people search
  const vueInstance = createApp({
    name: 'SearchIndex',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      SearchList,
      VacancyCard: defineAsyncComponent(() => import('@vue-components/cards/VacancyCard.vue')),
    },
  });

  // Mount the app
  vueInstance.mount('#search-index-app');
}
